import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Form, FormGroup} from 'reactstrap';
import {useForm} from "react-hook-form";
import {Btn} from "../../../../../AbstractElements";
import BackendDropDown from "../../../../../CommonElements/DropDown/BackendDropDown";
import TextInput from "../../../../../CommonElements/Input/TextInput";
import Loader from "../../../../../Layout/Loader";
import axiosConfig from "../../../../../Config/axios";
import AuthorizationContext from "../../../../../_helper/Authorization";
import {Collector, CollectorFormValues} from "../../Types/CollectorTypes";
import {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";
import {MultimediaField} from "../../../../SystemCore/Multimedia";

const CollectorForm = ({callBack, collector}: { callBack?: (collector: Collector) => void; collector?: Collector }) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler, authorizedUser} = authContext || {};
    const userRoles = (authorizedUser?.system_roles || []).map((role: string) => role?.toLowerCase());
    const isSuperAdminUser = userRoles.includes('super-admin');
    const isAdminUser = userRoles.includes('admin');

    const {
        register, handleSubmit, setError, clearErrors, formState: {errors}, setValue, getValues
    } = useForm<CollectorFormValues>();


    useEffect(() => {
        if (collector) {
            setValue('nic', collector.nic || '');
            setValue('registered_user_id', collector.user_id);
        }
    }, [collector, setValue]);

    useEffect(() => {
        if (!isSuperAdminUser && isAdminUser && authorizedUser?.id) {
            setValue('registered_user_id', authorizedUser.id);
        }
    }, [isSuperAdminUser, isAdminUser, authorizedUser?.id, setValue]);

    const onSubmit = (data: CollectorFormValues) => {
        clearErrors();
        if (!isSuperAdminUser && isAdminUser && authorizedUser?.id) {
            data.registered_user_id = authorizedUser.id;
        }
        setLoaderVisibility(true);
        collector ? updateCollector(data) : createCollector(data);
    };

    const createCollector = (data: CollectorFormValues) => {
        clearErrors();
        axiosConfig
            .post(`/application/collector`, data)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError as any);
                setLoaderVisibility(false);
            });
    };

    const updateCollector = (data: CollectorFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        const currentCollector = collector;
        if (!currentCollector) {
            setLoaderVisibility(false);
            return;
        }
        axiosConfig
            .put(`/application/collector/${currentCollector.id}`, data)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError as any);
                setLoaderVisibility(false);
            });
    };

    return (
        <Fragment>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Loader visibility={loaderVisibility}/>
                {isSuperAdminUser &&
                    <BackendDropDown name={'registered_user_id'} label={'Admin User'} nameColumn={'name'}
                                     getValues={getValues}
                                     register={register}
                                     params={{role_name: 'admin'}}
                                     errors={errors} url={'privilege/user'} options={{required: true}}/>}
                <TextInput name={'name'} type={'text'} label={'Name'} register={register}
                           errors={errors} placeholder={'Collector Name'} options={{required: true}}/>
                <TextInput name={'nic'} type={'text'} label={'NIC'} register={register}
                           errors={errors} placeholder={'123456789V'} options={{required: true}}/>
                <TextInput name={'contact_number'} type={'text'} label={'Contact Number'} register={register}
                           errors={errors} placeholder={'Contact Number'} options={{required: true}}/>
                <TextInput name={'address'} type={'text'} label={'Address'} register={register}
                           errors={errors} placeholder={'Address'} options={{required: true}}/>
                <MultimediaField name={'nic_front_image_id'} register={register} setValue={setValue}
                                 label={'NIC front'} />
                <MultimediaField name={'nic_back_image_id'} register={register} setValue={setValue}
                                 label={'NIC back'} />
                <FormGroup>
                    <Btn attrBtn={{
                        className: 'd-block w-100 mt-4',
                        color: 'primary',
                        type: 'submit'
                    }}>{collector ? 'Update' : 'Create'}</Btn>
                </FormGroup>
            </Form>
        </Fragment>
    );
};

export default CollectorForm;
